import React, { useMemo } from 'react';
import ApiServiceContext from '../../../services/contexts/ApiServiceContext';
import ApiService from '../../../services/ApiService';

const ApiServiceProvider: React.FC = ({ children }) => {
  const token = '';
  const apiService = useMemo(() => new ApiService(token), [token]);

  return (
    <ApiServiceContext.Provider value={{ apiService }}>
      {children}
    </ApiServiceContext.Provider>
  );
};

export default ApiServiceProvider;
